import React from 'react';

import ListOfCards from '../Entities/ListOfCards/ListOfCards';
import { Space } from '../../Utils/Types/Space';
import { CommunicationFilterType, UiSection } from '../../Utils/Types/UiSection';
import { Categories, PostType, Types } from '../../Utils/Types/Posts';

interface CommunicationListOfCardsProps {
  space: Space;
  uiSection: UiSection;
}

type Config = {
  postsTypes: PostType[];
  extraParams?: Record<string, any>;
};

const ConfigMapping: Record<CommunicationFilterType, Config> = {
  all: {
    postsTypes: Categories.COMMUNICATION,
  },
  pinned: {
    postsTypes: Categories.COMMUNICATION,
    extraParams: {
      'filter[is_pinned]': true,
    },
  },
  article: {
    postsTypes: [Types.ARTICLE],
  },
  event: {
    postsTypes: [Types.EVENT],
  },
};

export default function CommunicationListOfCards({
  space,
  uiSection,
}: CommunicationListOfCardsProps) {
  return (
    <ListOfCards
      space={space}
      viewAllHref={`/${space.slug}/news`}
      viewAllEnabled={space.communications_count > 1}
      {...ConfigMapping[uiSection.communication_type]}
    />
  );
}
